function TepelneProcesy(){
    return(
        <div>
            TepelneProcesy
        </div>
    );
};

export default TepelneProcesy;